import type { SupabaseClient } from '@supabase/supabase-js';

/** Repli si l'edge fn échoue (réseau, session pas encore rafraîchie...) — jamais bloquant. */
const FALLBACK_ICE_SERVERS: RTCIceServer[] = [{ urls: 'stun:stun.l.google.com:19302' }];

/**
 * `db`/`supabaseUrl` injectés (pas de singleton importé) : ce module est
 * partagé entre `apps/tutor` (salle web, tutor.jeraisonne.fr) et la route
 * native de `apps/app` — chaque app a son propre client Supabase.
 */
export async function fetchIceServers(
  roomId: string,
  db: SupabaseClient,
  supabaseUrl: string,
): Promise<RTCIceServer[]> {
  const {
    data: { session },
  } = await db.auth.getSession();
  if (!session) return FALLBACK_ICE_SERVERS;

  try {
    const res = await fetch(`${supabaseUrl}/functions/v1/visio-turn-credentials`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${session.access_token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ room_id: roomId }),
    });
    if (!res.ok) return FALLBACK_ICE_SERVERS;
    const body = (await res.json()) as { ice_servers?: RTCIceServer[] };
    return body.ice_servers?.length ? body.ice_servers : FALLBACK_ICE_SERVERS;
  } catch {
    return FALLBACK_ICE_SERVERS;
  }
}
